import { toast } from "react-toastify";
import * as actionTypes from "./actionTypes";
import cuentaService from "../../api/cuentaService";
import { decryptJsonValuesRecursive } from "../../util/cryptoUtils";

export const setCuentas = (cuentas) => {
  return { type: actionTypes.LOAD_CUENTAS, payload: { cuentas } };
};

export const setCuenta = (cuenta) => {
  return { type: actionTypes.LOAD_CUENTA, payload: { cuenta } };
};

export const setCuentasOperaciones = (cuentasOperaciones) => {
  return {
    type: actionTypes.LOAD_CUENTAS_OPERACIONES,
    payload: { cuentasOperaciones },
  };
};

export const setCuentasOperacionesPrymera = (cuentasOperacionesPrymera) => {
  return {
    type: actionTypes.LOAD_CUENTAS_OPERACIONES_PRYMERA,
    payload: { cuentasOperacionesPrymera },
  };
};

export const setCuentasDeposito = (cuentasDeposito) => {
  return {
    type: actionTypes.LOAD_CUENTAS_DEPOSITO,
    payload: { cuentasDeposito },
  };
};

const loadingCuentas = (loading) => {
  return { type: actionTypes.LOADING_CUENTAS, payload: { loading } };
};

const loadingCuenta = (loading) => {
  return { type: actionTypes.LOADING_CUENTA, payload: { loading } };
};

const loadingCuentasOperaciones = (loading) => {
  return {
    type: actionTypes.LOADING_CUENTAS_OPERACIONES,
    payload: { loading },
  };
};

const loadingCuentasOperacionesPrymera = (loading) => {
  return {
    type: actionTypes.LOADING_CUENTAS_OPERACIONES_PRYMERA,
    payload: { loading },
  };
};

const loadingCuentasDeposito = (loading) => {
  return {
    type: actionTypes.LOADING_CUENTAS_DEPOSITO,
    payload: { loading },
  };
};

const loadingMovimientos = (loading) => {
  return { type: actionTypes.LOADING_MOVIMIENTOS, payload: { loading } };
};

export const setMovimientos = (movimientos) => {
  return { type: actionTypes.LOAD_MOVIMIENTOS, payload: { movimientos } };
};

const setLoadingAperturarCuentaAhorrosValidar = (loading) => {
  return {
    type: actionTypes.LOADING_APERTURAR_CUENTA_AHORROS_VALIDAR,
    payload: { loading },
  };
};

const setLoadingAperturarCuentaAhorrosConfirmar = (loading) => {
  return {
    type: actionTypes.LOADING_APERTURAR_CUENTA_AHORROS_CONFIRMAR,
    payload: { loading },
  };
};

const setLoadingAperturarCuentaDPFValidar = (loading) => {
  return {
    type: actionTypes.LOADING_APERTURAR_CUENTA_DPF_VALIDAR,
    payload: { loading },
  };
};

const setLoadingAperturarCuentaDPFConfirmar = (loading) => {
  return {
    type: actionTypes.LOADING_APERTURAR_CUENTA_DPF_CONFIRMAR,
    payload: { loading },
  };
};

export const setProductosCuentaApertura = (productosCuenta) => {
  return {
    type: actionTypes.LOAD_PRODUCTOS_CUENTA_APERTURA,
    payload: { productosCuenta },
  };
};

const setLoadingProductosCuentaApertura = (loading) => {
  return {
    type: actionTypes.LOADING_PRODUCTOS_CUENTA_APERTURA,
    payload: { loading },
  };
};

export const getCuentas = () => async (dispatch) => {
  dispatch(loadingCuentas(true));
  try {
    let response = await cuentaService.listCuentas();
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setCuentas(response.data.cuentas));
    dispatch(loadingCuentas(false));
  } catch (error) {
    dispatch(loadingCuentas(false));
    toast.error(error);
  }
};

export const getCuentasOperaciones = () => async (dispatch) => {
  dispatch(loadingCuentasOperaciones(true));
  try {
    let response = await cuentaService.listCuentasOperaciones();
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setCuentasOperaciones(response.data.cuentas));
    dispatch(loadingCuentasOperaciones(false));
  } catch (error) {
    dispatch(loadingCuentasOperaciones(false));
    toast.error(error);
  }
};

export const getCuentasOperacionesPrymera = () => async (dispatch) => {
  dispatch(loadingCuentasOperacionesPrymera(true));
  try {
    let response = await cuentaService.listCuentasOperacionesPrymera();
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setCuentasOperacionesPrymera(response.data.cuentas));
    dispatch(loadingCuentasOperacionesPrymera(false));
  } catch (error) {
    dispatch(loadingCuentasOperacionesPrymera(false));
    toast.error(error);
  }
};

export const getCuentasDeposito = () => async (dispatch) => {
  dispatch(loadingCuentasDeposito(true));
  try {
    let response = await cuentaService.listCuentasDeposito();
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setCuentasDeposito(response.data.cuentas));
    dispatch(loadingCuentasDeposito(false));
  } catch (error) {
    dispatch(loadingCuentasDeposito(false));
    toast.error(error);
  }
};

export const getCuenta = (request) => async (dispatch) => {
  dispatch(loadingCuenta(true));
  try {
    let response = await cuentaService.cuentaDetail(request);
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setCuenta(response.data.cuenta));
    dispatch(loadingCuenta(false));
  } catch (error) {
    dispatch(loadingCuenta(false));
    toast.error(error);
  }
};

export const getMovimientos = (request) => async (dispatch) => {
  dispatch(loadingMovimientos(true));
  try {
    let response = await cuentaService.listMovimientos(request);
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setMovimientos(response.data.movimientos));
    dispatch(loadingMovimientos(false));
  } catch (error) {
    dispatch(loadingMovimientos(false));
    toast.error(error);
  }
};

export const aperturarCuentaAhorrosValidar = (request) => async (dispatch) => {
  dispatch(setLoadingAperturarCuentaAhorrosValidar(true));
  try {
    let response = await cuentaService.aperturarCuentaAhorrosValidar(request);
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setLoadingAperturarCuentaAhorrosValidar(false));
    return response.data;
  } catch (error) {
    dispatch(setLoadingAperturarCuentaAhorrosValidar(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const aperturarCuentaAhorrosConfirmar = (request) => async (
  dispatch
) => {
  dispatch(setLoadingAperturarCuentaAhorrosConfirmar(true));
  try {
    let response = await cuentaService.aperturarCuentaAhorrosConfirmar(
      request
    );
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setLoadingAperturarCuentaAhorrosConfirmar(false));
    return response.data;
  } catch (error) {
    dispatch(setLoadingAperturarCuentaAhorrosConfirmar(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const aperturarCuentaDPFValidar = (request) => async (dispatch) => {
  dispatch(setLoadingAperturarCuentaDPFValidar(true));
  try {
    let response = await cuentaService.aperturarCuentaDPFValidar(request);
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setLoadingAperturarCuentaDPFValidar(false));
    return response.data;
  } catch (error) {
    dispatch(setLoadingAperturarCuentaDPFValidar(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const aperturarCuentaDPFConfirmar = (request) => async (dispatch) => {
  dispatch(setLoadingAperturarCuentaDPFConfirmar(true));
  try {
    let response = await cuentaService.aperturarCuentaDPFConfirmar(request);
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setLoadingAperturarCuentaDPFConfirmar(false));
    return response.data;
  } catch (error) {
    dispatch(setLoadingAperturarCuentaDPFConfirmar(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const getProductosCuentaApertura = (request) => async (dispatch) => {
  dispatch(setLoadingProductosCuentaApertura(true));
  try {
    let response = await cuentaService.listarProductosCuentaApertura(request);
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
    dispatch(setProductosCuentaApertura(response.data.productosCuenta));
    dispatch(setLoadingProductosCuentaApertura(false));
  } catch (error) {
    dispatch(setLoadingProductosCuentaApertura(false));
    toast.error(error);
  }
};
